import { render, staticRenderFns } from "./WarrantyExtendedField.vue?vue&type=template&id=73ab1d4b&scoped=true"
import script from "./WarrantyExtendedField.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarrantyExtendedField.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WarrantyExtendedField.vue?vue&type=style&index=0&id=73ab1d4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ab1d4b",
  null
  
)

export default component.exports